<po-page-default
  [p-breadcrumb]="breadcrumb"
  [p-actions]="actions"
  p-title="Pedido de Venda {{acaoTela}}"
>

  <form #formPedido="ngForm" class="po-row">
    <po-select
      class="po-md-4"
      name="CC5TIPO"
      [(ngModel)]="pedido.CC5TIPO"
      p-label="Tipo Pedido"
      [p-options]="varTipoPedido"
      [p-required]="true"
      p-show-required="true"
      (p-change)="alteraTipoPedido()"
      [p-disabled]="disableSalvar"
    ></po-select>
    @if (pedido.CC5TIPO !== 'B') {
      <po-lookup class="po-md-4"
        name="CC5CLIENTELOJA"
        [(ngModel)]="pedido.CC5CLIENTELOJA"
        p-field-label="CA1NREDUZ"
        p-field-value="CA1CODLOJA"
        p-label="Cliente"
        [p-columns]="columnsClienteFilters"
        [p-field-format]="fieldFormaterClienteFilters"
        [p-filter-service]="clienteLookupService"
        [p-advanced-filters]="advancedClienteFilters"
        [p-literals]="{ modalTitle: 'Cliente' }"
        (p-selected)="clienteSelecionado($event)"
        [p-disabled]="disableSalvar"
      ></po-lookup>
    } @else {
      <po-lookup class="po-md-4"
        name="CC5FORNECEDORLOJA"
        [(ngModel)]="pedido.CC5FORNECEDORLOJA"
        p-field-label="CA2NREDUZ"
        p-field-value="CA2CODLOJA"
        p-label="Fornecedor"
        [p-columns]="columnsFornecedorFilters"
        [p-field-format]="fieldFormaterFornecedorFilters"
        [p-filter-service]="fornecedorLookupService"
        [p-advanced-filters]="advancedFornecedorFilters"
        [p-literals]="{ modalTitle: 'Fornecedor' }"
        (p-selected)="fornecedorSelecionado($event)"
        [p-disabled]="disableSalvar"
      ></po-lookup>
    }
    <po-lookup
      class="po-md-4"
      name="CC5CONDPAG"
      [(ngModel)]="pedido.CC5CONDPAG"
      p-field-value="CE4CODIGO"
      p-field-label="CE4DESCRI"
      p-label="Condição Pgto"
      [p-columns]="columnsCondicaoPagamentoFilters"
      [p-field-format]="fieldFormaterCondicaoPagamentoFilters"
      [p-filter-service]="condicaoPagamentoLookupService"
      [p-advanced-filters]="advancedCondicaoPagamentoFilters"
      [p-literals]="{ modalTitle: 'Condição de Pagamento' }"
      [p-required]="true"
      p-show-required="true"
      [p-disabled]="disableSalvar"
    ></po-lookup>
    <po-select
      class="po-md-4"
      name="CC5TPFRETE"
      [(ngModel)]="pedido.CC5TPFRETE"
      p-label="Tipo Frete"
      [p-options]="varTipoFrete"
      [p-required]="true"
      [p-disabled]="true"
      p-show-required="true"
    ></po-select>
    <po-select
      class="po-md-4"
      name="CC5TIPOCLI"
      [(ngModel)]="pedido.CC5TIPOCLI"
      p-label="Tipo Cliente"
      [p-options]="varTipoCliente"
      [p-required]="true"
      [p-disabled]="true"
      p-show-required="true"
    ></po-select>
    <po-lookup
      class="po-md-4"
      p-label="Guarita"
      name="CC5GUARITA"
      [(ngModel)]="pedido.CC5GUARITA"
      p-field-value="CZPRCHAVE"
      p-field-label="CZPRGENERI"
      [p-columns]="guaritaColumnsFilters"
      [p-field-format]="guaritaFieldFormaterFilters"
      [p-filter-service]="zprLookupService"
      [p-advanced-filters]="guaritaAdvancedFilters"
      [p-literals]="{ modalTitle: 'Guarita' }"
      [p-required]="true"
      [p-disabled]="disableSalvar"
      p-show-required="true"
    ></po-lookup>
    <po-lookup
      class="po-md-4"
      name="CC5MENPAD"
      [(ngModel)]="pedido.CC5MENPAD"
      p-field-label="CM4DESCR"
      p-field-value="CM4CODIGO"
      p-label="Mens. Padrão"
      [p-columns]="columnsFormulaFilters"
      [p-field-format]="fieldFormaterFormulaFilters"
      [p-filter-service]="formulaService"
      [p-advanced-filters]="advancedFormulaFilters"
      [p-literals]="{ modalTitle: 'Mensagem Padrão' }"
      [p-disabled]="disableSalvar"
    ></po-lookup>
    <po-datepicker
      class="po-md-4"
      name="DC5DTENTR"
      [(ngModel)]="pedido.DC5DTENTR"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Pedido visível até"
      [p-required]="true"
      p-show-required="true"
    ></po-datepicker>
    <po-select
      class="po-md-4"
      name="CC5EHCOMP"
      [(ngModel)]="pedido.CC5EHCOMP"
      p-label="Pedido Complementar"
      [p-options]="varPedidoComplementar"
      [p-required]="true"
      p-show-required="true"
    ></po-select>
    <po-input
      class="po-md-4"
      name="CC5MENNOTA"
      p-maxlength="75"
      [(ngModel)]="pedido.CC5MENNOTA"
      p-label="Mens. Nota"
      [p-disabled]="disableSalvar"
    ></po-input>
    <po-input
      class="po-md-4"
      name="CC5MENNOT2"
      p-maxlength="120"
      [(ngModel)]="pedido.CC5MENNOT2"
      p-label="Mens. Nota 2"
      [p-disabled]="disableSalvar"
    ></po-input>
    <po-input
      class="po-md-4"
      name="CC5MENNOT3"
      p-maxlength="120"
      [(ngModel)]="pedido.CC5MENNOT3"
      p-label="Mens. Nota 3"
      [p-disabled]="disableSalvar"
    ></po-input>
  </form>
  <po-divider class="po-md-12"></po-divider>
  <div class="po-row">
    @if(podeSalvar){
      <po-button  class="po-md-3 po-mt-2" p-kind="secondary" p-label="Novo Item" (p-click)="btnNovoItem()"></po-button>
    }
    <po-table class="po-sm-12 po-md-12 po-lg-12 po-mt-1"
      [p-hide-select-all]="true"
      [p-striped]="true"
      p-hide-columns-manager="true"
      [p-columns]="colunas"
      [p-items]="itens"
      p-spacing="small"
      p-container="true"
    ></po-table>
  </div>
</po-page-default>

<po-modal #itemModal p-title="{{acao}} Item {{itemPedido.CC6ITEM}}" p-size="xl">

  <form #formItem="ngForm">

    <po-lookup
      class="po-md-12"
      name="CC6PRODUTO"
      [(ngModel)]="itemPedido.CC6PRODUTO"
      p-field-label="CB1DESC"
      p-field-value="CB1COD"
      p-label="Produto"
      [p-columns]="columnsProdutoFilters"
      [p-field-format]="fieldFormaterProdutoFilters"
      [p-filter-service]="produtoLookupService"
      [p-advanced-filters]="advancedProdutoFilters"
      [p-literals]="{ modalTitle: 'Produto' }"
      [p-filter-params]="{CB1MSBLQL: '2'}"
      (p-selected)="produtoSelecionado($event)"
    ></po-lookup>
    <po-lookup
      class="po-md-6"
      name="CC6OPER"
      [(ngModel)]="itemPedido.CC6OPER"
      p-field-value="CX5CHAVE"
      p-field-label="CX5DESCRI"
      p-label="Tipo Operação"
      p-filter-service="{{urlApiProtheus}}/wsrbase/sx5/DJ"
      [p-literals]="{ modalTitle: 'Tipos Operação' }"
      [p-columns]="baseService.colunasListaSX5"
      [p-field-format]="baseService.getFieldFormaterSX5"
      (p-selected)="selectTipoOpercao($event)"
      p-required="true"
      p-show-required="true"
      p-placeholder="Pesquisar"
      [p-disabled]="!(itemPedido.CC6PRODUTO && (pedido.CC5CLIENTELOJA || pedido.CC5FORNECEDORLOJA)) "
    ></po-lookup>
    <po-lookup
      class="po-md-6"
      name="CC6TES"
      [(ngModel)]="itemPedido.CC6TES"
      p-field-value="CF4CODIGO"
      p-field-label="CF4TEXTO"
      p-label="TES"
      [p-columns]="columnsTesFilters"
      [p-field-format]="fieldFormaterTesFilters"
      [p-filter-service]="tesLookupService"
      [p-advanced-filters]="advancedTesFilters"
      [p-literals]="{ modalTitle: 'TES' }"
      p-disabled="true"
      p-required="true"
    ></po-lookup>
    <po-decimal
      class="po-md-6"
      name="NC6QTDVEN"
      [(ngModel)]="itemPedido.NC6QTDVEN"
      p-label="Quantidade"
      [p-decimals-length]="3"
      [p-min]="0.00"
      p-required
      p-show-required="true"
    ></po-decimal>
    <po-decimal
      class="po-md-6"
      name="NC6PRCVEN"
      [(ngModel)]="itemPedido.NC6PRCVEN"
      p-label="Preço Unitário"
      [p-decimals-length]="5"
      [p-min]="0.00"
      p-required
      p-show-required="true"
    ></po-decimal>
    <po-input
      class="po-md-6"
      name="CC6NUMPCOM"
      p-maxlength="15"
      [(ngModel)]="itemPedido.CC6NUMPCOM"
      p-label="Pedido Compra Cliente"
    ></po-input>
    <po-input
      class="po-md-6"
      name="CC6ITEMPC"
      p-maxlength="6"
      [(ngModel)]="itemPedido.CC6ITEMPC"
      p-label="Item Pedido de Compra"
    ></po-input>
    <po-lookup
      class="po-md-6"
      name="CC6ZCDNEGO"
      [(ngModel)]="itemPedido.CC6ZCDNEGO"
      p-field-label="CZACDSCFAZ"
      p-field-value="CZACCDNGC"
      p-label="Estimativa Negociação"
      [p-columns]="columnsEstimativaNegociacaoFilters"
      [p-field-format]="fieldFormaterEstimativaNegociacaoFilters"
      [p-filter-service]="estimativaNegociacaoLookupService"
      [p-advanced-filters]="advancedEstimativaNegociacaoFilters"
      [p-literals]="{ modalTitle: 'Estimativa Negociação' }"
      p-required
      p-show-required="true"
    ></po-lookup>
  </form>
  <po-modal-footer>
    <po-button
      p-label="Salvar"
      p-kind="primary"
      (p-click)="salvarItemPedido()"
      [p-disabled]="formItemValidar()"
    ></po-button>
  </po-modal-footer>
</po-modal>


